import { useCallback, useContext } from 'react'
import type { Moment } from 'moment'
import useExperienceDateDisplayValue from 'components/Experiences/hooks/useExperienceDateDisplayValue'
import useExperienceSearchLabels from 'components/Experiences/hooks/useExperienceSearchLabels'
import ExperienceDateFloatingPanel from 'components/SearchV2/Components/Mobile/Panels/ExperienceDateFloatingPanel'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { DATE_SEARCH_OPTION_IDS } from 'constants/search'
import { GlobalSearchDispatchContext, GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'

interface Props {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  onConfirm: () => void
  whenLabel: string
  anytimePlaceholder: string
  tripDateRange?: { start: Moment, end: Moment }
}

function ListingDrawerMobileExperienceDateFields({
  isOpen,
  onOpen,
  onClose,
  onConfirm,
  whenLabel,
  anytimePlaceholder,
  tripDateRange,
}: Props) {
  const { checkinDate, checkoutDate, dateSearchOptionId } = useContext(GlobalSearchStateContext)
  const globalSearchDispatch = useContext(GlobalSearchDispatchContext)
  const { clearAllLabel, searchLabel } = useExperienceSearchLabels()
  const dateFieldDisplayValue = useExperienceDateDisplayValue(checkinDate, checkoutDate)

  const isAnytime = dateSearchOptionId === DATE_SEARCH_OPTION_IDS.ANYTIME && !checkinDate
  const confirmButtonDisabled = !checkinDate && !isAnytime

  const handleSelectAnytime = useCallback(() => {
    globalSearchDispatch({ type: GlobalSearchStateActions.UNSET_CHECKIN_DATE })
    globalSearchDispatch({ type: GlobalSearchStateActions.UNSET_CHECKOUT_DATE })
    globalSearchDispatch({ type: GlobalSearchStateActions.UNSET_FLEXIBLE_DURATION })
    globalSearchDispatch({ type: GlobalSearchStateActions.UNSET_FLEXIBLE_MONTH_RANGE })
    globalSearchDispatch({ type: GlobalSearchStateActions.UNSET_USER_SELECTED_FLEXIBLE_MONTHS })
    globalSearchDispatch({
      type: GlobalSearchStateActions.SET_DATE_SEARCH_OPTION,
      optionId: DATE_SEARCH_OPTION_IDS.ANYTIME,
    })
    globalSearchDispatch({
      type: GlobalSearchStateActions.TOGGLE_ANYTIME_DATES_SELECTED,
      selected: true,
    })
  }, [globalSearchDispatch])

  return (
    <>
      <ExperienceDateFloatingPanel
        isOpen={isOpen}
        onClose={onClose}
        onGoBack={onClose}
        onConfirm={onConfirm}
        confirmText={searchLabel}
        confirmButtonDisabled={confirmButtonDisabled}
        secondaryActionText={clearAllLabel}
        onSecondaryActionClick={handleSelectAnytime}
        title={whenLabel}
        tripDateRange={tripDateRange}
        showNextBooking={false}
      />

      <SearchFormField
        label={whenLabel}
        placeholder={anytimePlaceholder}
        value={dateFieldDisplayValue}
        onClick={onOpen}
      />
    </>
  )
}

export default ListingDrawerMobileExperienceDateFields
